var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIa3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 179,
    viewBox: "0 0 56 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5704 26.7834C54.4913 12.2246 42.6393 0.756348 28.1776 0.756348C13.7158 0.756348 1.86379 12.2246 0.78469 26.7834H0.70459V148.243H0.78469C0.731677 148.959 0.70459 149.682 0.70459 150.412C0.70459 165.984 13.0047 178.608 28.1776 178.608C43.3504 178.608 55.6505 165.984 55.6505 150.412C55.6505 149.682 55.6234 148.959 55.5704 148.243H55.6505V26.7834H55.5704Z",
    fill: "#F39100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIa3);
export default __webpack_public_path__ + "static/media/IA_3.c5df9fbb26f3d8f9a515be5071f98e95.svg";
export { ForwardRef as ReactComponent };